// extracted by mini-css-extract-plugin
export default {"switch_wrapper":"Switch_switch_wrapper__2AL31"};